import React, { useEffect, useState } from "react";
import { Box, Button } from "@mui/material";
import { ResourceLinks } from "../../../../constants";
import { useSelector } from "../../../../store";

export default function WebNumeracySelectImg({ question, onAnswer = () => {} }) {
    const questionData = question;
    const learnerState = useSelector((state) => state.learner || {});
    const data = learnerState?.details?.testLevel === "vfh" ? questionData?.vfh : questionData?.acsf4;
    const imagesResources = ResourceLinks.llnQuizImage;
    const [selectedOption, setSelectedOption] = useState(null);

    // every time question change we will set to reset needed to reset
    useEffect(() => {
        setSelectedOption(null)
    }, [question]);

    const handleOptionClick = (option) => {
        setSelectedOption(option); 

        const canProceed = option !== "";
        onAnswer({
            canProceed,
            answer: option,
        });
    };

    return (
        <Box
            sx={{
                width: "100%",
                maxWidth: 854,
                margin: "0 auto",
                padding: "20px",
                paddingBottom: "60px",
                position: "relative",
                backgroundColor: "white",
            }}
        >
            {/* Inner container to maintain aspect ratio */}
            <Box
                sx={{
                    width: "100%",
                    aspectRatio: "854 / 450", // Keep the aspect ratio of the image
                    position: "relative",
                    backgroundImage: `url(${imagesResources}${data.image})`,
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                }}
            >
                {Object.keys(data.options).map((key) => {
                    const option = data.options[key].value;
                    const top = data.options[key].top;
                    const left = data.options[key].left;

                    return (
                        <Button
                            key={key}
                            variant="contained"
                            onClick={() => handleOptionClick(option)}
                            sx={{
                                position: "absolute",
                                top: top,
                                left: left,
                                transform: "translate(-50%, -50%)",
                                color: "black",
                                width: "220px",
                                height: "70px",
                                fontSize: "20px",
                                backgroundColor: selectedOption === option
                                    ? "rgb(175, 226, 62)"
                                    : "rgb(218, 218, 218)",
                                borderBottom: `10px solid ${
                                    selectedOption === option
                                        ? "rgb(99, 151, 41)"
                                        : "rgb(128, 128, 128)"
                                }`,
                                fontWeight: "bold",
                                "&.MuiButton-contained": {
                                    backgroundColor: selectedOption === option
                                        ? "rgb(175, 226, 62)"
                                        : "rgb(218, 218, 218)",
                                    boxShadow: "none",
                                },
                                "&:hover.MuiButton-contained": {
                                    backgroundColor: selectedOption === option
                                        ? "rgb(175, 226, 62)"
                                        : "rgb(218, 218, 218)",
                                    boxShadow: "none",
                                },
                            }}
                        >
                            {option}
                        </Button>
                    );
                })}
            </Box>
        </Box>
    );
};
